/**
 * How a delivered set of discharge instructions is ordered and titled for the
 * patient, wherever it is shown: their Discharge Instructions page, the page a
 * scanned QR opens, and the PDF. Mirrors the category order of the provider's
 * DischargeStep so both sides read the same.
 */

export const DISCHARGE_CATEGORY_ORDER = [
  'medication_general',
  'medication_specific',
  'activity',
  'diet',
  'followup',
  'warning_signs',
  'wound_care',
  'other',
];

export const sortDischargeInstructions = (instructions) =>
  [...(Array.isArray(instructions) ? instructions : [])].sort(
    (a, b) =>
      DISCHARGE_CATEGORY_ORDER.indexOf(a.category || 'other') -
      DISCHARGE_CATEGORY_ORDER.indexOf(b.category || 'other'),
  );

export const dischargeInstructionTitle = (inst) =>
  inst.medicationName ? `${inst.title}: ${inst.medicationName}` : inst.title;
